<template>
  <div class="yh_harvest">
    <section class="harvest_banner">
      <div class="harvest_search_box harvest_search_box_else_width" id="harvest_search_box2">
        <h4 class="form_h4">【文献数据库】</h4>
        <el-form ref="form">
          <p class="harvest_type">
            <el-radio v-model="literature_type" label="1">年鉴库</el-radio>
            <el-radio v-model="literature_type" label="2">期刊库</el-radio>
            <el-radio v-model="literature_type" label="3">得奖数据库</el-radio>
          </p>

          <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库开始-->
          <div class="form_param" v-show="literature_type == 1 || literature_type == 2">
            <el-form-item label-width="35px" label="周期" class="harvest_param left">
              <el-select v-model="form1.cycle" placeholder="请选择课题类型" class="harvest_inp">
                <el-option v-for="x in topic_type_arr" :label="x.name" :value="x.id" :key="x.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="66px" label="出版时间" class="harvest_param right">
              <el-date-picker
                class="harvest_inp"
                v-model="form1.publish_time"
                type="daterange"
                range-separator="至"
                start-placeholder
                end-placeholder
              ></el-date-picker>
            </el-form-item>
          </div>

          <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库玩-->
          <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库start-->
          <div v-show="literature_type == 3" class="form_param">
            <el-form-item label-width="66px" label="成果名称" class="harvest_param left">
              <el-input v-model="form2.achievement_name" placeholder="请输入成果名称" class="harvest_inp"></el-input>
            </el-form-item>
            <el-form-item label-width="66px" label="作者" class="harvest_param right">
              <el-input v-model="form2.author" placeholder="请输入作者" class="harvest_inp"></el-input>
            </el-form-item>
            <el-form-item label-width="66px" label="成果类型" class="harvest_param left">
              <el-select v-model="form2.achievement_type" placeholder="请选择成果类型" class="harvest_inp">
                <el-option v-for="x in topic_type_arr1" :label="x.name" :value="x.id" :key="x.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="66px" label="成果期次" class="harvest_param right">
              <el-select
                v-model="form2.achievement_period"
                placeholder="请选择成果期次"
                class="harvest_inp"
              >
                <el-option v-for="x in topic_type_arr2" :label="x.name" :value="x.id" :key="x.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="66px" label="活动奖项" class="harvest_param left">
              <el-select v-model="form2.prize" placeholder="请选择活动奖项" class="harvest_inp">
                <el-option v-for="x in topic_type_arr3" :label="x.name" :value="x.id" :key="x.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="66px" label="成果类别" class="harvest_param right">
              <el-select v-model="form2.category" placeholder="请选择成果类别" class="harvest_inp">
                <el-option v-for="x in topic_type_arr1" :label="x.name" :value="x.id" :key="x.name"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库end-->
          <div class="harest_btn_box" style="padding-left: 62px;">
            <el-button type="primary" class="harvest_btn" @click="search_fn">搜索</el-button>
            <el-button class="harvest_btn gray_btn" @click="reset_fn">重置</el-button>
          </div>
        </el-form>
      </div>
    </section>

    <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库表格-->
    <section class="harvest_tab_box">
      <div class="width1000">
        <el-table
          :data="tab_list[current_page]"
          class="width1000"
          width="1000"
          v-show="literature_type == 1 || literature_type == 2 "
        >
          <el-table-column label="序号" prop="idx" width="50"></el-table-column>
          <el-table-column prop="name" label="期刊名"></el-table-column>
          <el-table-column prop="a" width="100" label="周期"></el-table-column>
          <el-table-column prop="b" width="110" label="期号"></el-table-column>
          <el-table-column prop="c" label="主办单位"></el-table-column>
          <el-table-column prop="g" width="90" label="阅读数"></el-table-column>

          <el-table-column fixed="right" width="90" label="操作">
            <template slot-scope="scope">
              <span @click.prevent="to_detial(scope.row.id)" class="msg_btn pointer">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库表格完成-->
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库开始-->
        <el-table
          :data="tab_list[current_page]"
          class="width1000"
          width="1000"
          v-show="literature_type == 3 "
        >
          <el-table-column label="序号" prop="idx" width="50"></el-table-column>
          <el-table-column prop="name" label="成果名称"></el-table-column>
          <el-table-column prop="e" width="100" label="成果类别"></el-table-column>
          <el-table-column prop="d" width="90" label="成果属性"></el-table-column>
          <el-table-column prop="c" label="作者/编者"></el-table-column>
          <el-table-column prop="h" width="70" label="成果期次"></el-table-column>
          <el-table-column prop="i" label="获得奖项"></el-table-column>
          <el-table-column prop="g" width="90" label="阅读数"></el-table-column>

          <el-table-column fixed="right" width="90" label="操作">
            <template slot-scope="scope">
              <span @click.prevent="to_detial(scope.row.id)" class="msg_btn pointer">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库开始-->
        <el-pagination
          class="mid"
          background
          :page-size="num_s"
          v-show="data_len > 0"
          layout="prev, pager, next"
          @current-change="get_page"
          :total="data_len"
        ></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { yh_post } from "../../api";
import { fn_pos_mid } from "../../assets/js/harvest";
import { sort_arr } from "../../assets/js/public";
export default {
  data() {
    return {
      literature_type: "1",
      form1: {
        cycle: -1,
        publish_time: ""
      },
      form2: {
        achievement_name: "",
        author: "",
        achievement_type: -1,
        achievement_period: -1,
        prize: -1,
        category: -1
      },
      tab_data1: [],
      tab_data2: [],
      topic_type_arr: [
        {
          name: "全部",
          id: -1
        },
        {
          name: "季刊",
          id: 1
        },
        {
          name: "月刊",
          id: 2
        }
      ],
      topic_type_arr1: [
        {
          name: "全部",
          id: -1
        },
        {
          name: "论文",
          id: 1
        },
        {
          name: "报告",
          id: 2
        }
      ],
      topic_type_arr2: [
        {
          name: "全部",
          id: -1
        },
        {
          name: "专著",
          id: 1
        },
        {
          name: "教材",
          id: 2
        }
      ],
      topic_type_arr3: [
        {
          name: "全部",
          id: -1
        },
        {
          name: "一等奖",
          id: 1
        },
        {
          name: "二等奖",
          id: 2
        }
      ],
      current_page: 0,
      tab_list: [],
      data_len: 0, //数据总数
      num_s: 10
    };
  },
  methods: {
    open(txt) {
      this.$alert(txt, "温馨提示", {
        confirmButtonText: "确定"
      });
    },
    get_tab1_fn() {
      this.$api.axios_literature1(this.form1).then(res => {
        this.tab_data1 = res.data;
        this.data_len = this.tab_data1.length;
        this.tab_list = sort_arr(this.tab_data1, this.num_s);
      });
    },
    get_tab1_fn() {
      this.$api.axios_literature2(this.form1).then(res => {
        this.tab_data1 = res.data;
        this.data_len = this.tab_data1.length;
        this.tab_list = sort_arr(this.tab_data1, this.num_s);
      });
    },
    get_tab3_fn() {
      this.$api.axios_literature3(this.form2).then(res => {
        this.tab_data2 = res.data;
        this.data_len = this.tab_data2.length;
        this.tab_list = sort_arr(this.tab_data2, this.num_s);
      });
    },
    check_fn() {
      if (this.literature_type == "1" || this.literature_type == "2") {
        if (this.form1.cycle == "") {
          this.open("请填写周期");
          return false;
        }
        // if(this.form1.publish_time == ""){
        // 	this.open("请选择出版时间");
        // 	return false;
        // };
        return true;
      } else {
        // if(this.form2.achievement_name == ""){
        // 	this.open("请填写成果名称");
        // 	return false;
        // };
        // if(this.form2.author == ""){
        // 	this.open("请填写作者");
        // 	return false;
        // };
        if (this.form2.achievement_type == "") {
          this.open("请选择成果类型");
          return false;
        }
        if (this.form2.achievement_period == "") {
          this.open("请选择成果期次");
          return false;
        }
        if (this.form2.prize == "") {
          this.open("请选择活动奖项");
          return false;
        }
        if (this.form2.category == "") {
          this.open("请选择成果类别");
          return false;
        }
        return true;
      }
    },
    search_fn() {
      if (this.check_fn()) {
        this.tab_data1 = require("../../../static/json/top.2.json");
        this.data_len = this.tab_data1.length;
        this.tab_list = sort_arr(this.tab_data1, this.num_s);
        this.tab_data2 = require("../../../static/json/top.2.json");
        this.data_len = this.tab_data2.length;
        this.tab_list = sort_arr(this.tab_data2, this.num_s);
        if (this.harvest_type == "1") {
          this.get_tab1_fn();
        } else if (this.harvest_type == "2") {
          this.get_tab2_fn();
        } else {
          this.get_tab3_fn();
        }
      }
    },
    reset_fn() {
      this.form1 = {
        cycle: -1,
        publish_time: ""
      };
      this.form2 = {
        achievement_name: "",
        author: "",
        achievement_type: -1,
        achievement_period: -1,
        prize: -1,
        category: -1
      };
    },
    to_detial(id) {
      this.$router.push({ path: "/details", query: { id: id } });
    },
    get_page(d) {
      this.current_page = d - 1;
    }
  },
  mounted() {
    fn_pos_mid("harvest_search_box2");
  },
  updated() {
    fn_pos_mid("harvest_search_box2");
  },
  watch: {
    literature_type: function(val) {
      this.reset_fn();
      this.tab_list = [];
      this.data_len = 0;
      this.current_page = 0;
    }
  },
  created: function() {
    if (localStorage.getItem("doc_token") == null) {
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@import url("../../assets/css/index");*/
@import url("../../assets/css/else.css");
@import url("../../assets/css/harvest.css");
</style>



// WEBPACK FOOTER //
// src/components/harvest/literature.vue